// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IShortIfrastuctureItem {
  /** Тип безопасности **/
  type: EType;
  /** Значение **/
  title: string;
}

export enum EType {
  /** Школа **/
  'School' = 'school',
  /** Детский сад **/
  'Kindergarten' = 'kindergarten',
  /** Поликлиника **/
  'Polyclinic' = 'polyclinic',
  /** Детские площадки **/
  'Children' = 'children',
  /** Спортивные площадки **/
  'Sport' = 'sport',
  /** Места для отдыха **/
  'Recreation' = 'recreation',
  /** Площадки для выгула собак **/
  'Dogs' = 'dogs',
  /** Супермаркет **/
  'Supermarket' = 'supermarket',
  /** Рестораны **/
  'Restaurant' = 'restaurant',
  /** Фитнес-центр **/
  'Fitness' = 'fitness',
  /** SPA-центо **/
  'Spa' = 'spa',
  /** Бассейн **/
  'Pool' = 'pool',
  /** Пункты бытового обслуживания **/
  'Domestic' = 'domestic',
  /** Коммерческие объекты **/
  'Commerce' = 'commerce',
  /** Офисы **/
  'Offices' = 'offices',
}
